import React, { useEffect, useState } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, query, orderBy, limit, onSnapshot, addDoc, serverTimestamp } from 'firebase/firestore';
import { Avatar } from 'tabler-react';
import { userImg, firebaseConfig } from '../../lib/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mapIcon } from '../../lib/helpers';
import './style.css';

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const Chat = ({ user: { ID, username, photo }, onClose }) => {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');

    useEffect(() => {
        if (db) {
            const q = query(
                collection(db, `Admin_To_${ID}`),
                orderBy('createdAt'),
                limit(100)
            );

            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                const data = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setMessages(data);
            });

            return unsubscribe;
        }
    }, [ID]);

    const sendMessage = async (e) => {
        e.preventDefault();

        if (db) {
            await addDoc(collection(db, `Admin_To_${ID}`), {
                text: newMessage,
                type: 'admin',
                createdAt: serverTimestamp()
            });

            setNewMessage('');
        }
    };

    return (
        <div className="chatDiv">
            <div className="header">
                <span>Chat</span>

                <FontAwesomeIcon icon={mapIcon("faTimes")} className="close" onClick={onClose} />
            </div>

            <div className="messages">
                {messages.map(message =>
                    <div key={message.id} className={`message ${message.type}`}>
                        <div className="username">{message.type === "admin" ? 'Me' : username}</div>

                        <div className="content">
                            <Avatar size="sm" imageURL={message.type === "admin" ? userImg : photo} />
                            <div className="text">{message.text}</div>
                        </div>
                    </div>
                )}
            </div>

            <div className="newMessage">
                <textarea 
                    value={newMessage} 
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Enter Message"
                ></textarea>
                <button onClick={sendMessage}>Send</button>
            </div>
        </div>
    );
}

export default Chat